import type Customer from "@acto/taskpane/core/domain/Customer";

// An https URL rather than a `geo:`/`maps:` scheme because only this form works on both
// platforms: iOS and Android each claim google.com/maps as an app link, so an installed
// Google Maps app takes the URL and everything else falls back to the web map. iOS registers
// no handler for `geo:` at all, where the tap silently does nothing.
const MAPS_SEARCH_URL = "https://www.google.com/maps/search/?api=1&query=";

type Addressable = Pick<Customer, "street" | "postcode" | "city" | "country">;

/**
 * A map link for the customer's address, or null when the address cannot identify a building.
 * A street with no town, or a town with no street, resolves to a plausible-looking pin
 * somewhere else, so those are no link rather than a wrong one.
 */
export const mapsSearchUrl = (customer: Addressable): string | null => {
  const hasTown = Boolean(customer.postcode || customer.city);
  if (!customer.street || !hasTown) return null;

  const town = [customer.postcode, customer.city].filter(Boolean).join(" ");
  const query = [customer.street, town, customer.country].filter(Boolean).join(", ");
  return `${MAPS_SEARCH_URL}${encodeURIComponent(query)}`;
};
